import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AsyncPipe, CurrencyPipe } from '@angular/common';
import type { ApiState } from '@comparit/core';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';
import { ResultsBaseService } from '../../services/results-base.service';

/** The Tarifdetails header card: insurer logo, tariff name and the premium. */
@Component({
  selector: 'ui-tarif-header',
  templateUrl: './tarif-header.component.html',
  styleUrl: './tarif-header.component.scss',
  imports: [AsyncPipe, CurrencyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TarifHeaderComponent {
  protected readonly results: ResultsBaseService<unknown, ErgebnisInput> =
    inject(ResultsBaseService);

  readonly bafinRegNr = input.required<string>();
  readonly versichererName = input.required<string>();
  readonly tarifName = input.required<string>();
  /** Binding price from the insurer; only trusted while `state` is `success`. */
  readonly confirmedBetrag = input.required<number | null>();
  /** Price from the calculation result, shown as provisional until the insurer confirmed one. */
  readonly provisionalBetrag = input<number | null>(null);
  /** State of the get-order step (binding price + documents). */
  readonly state = input.required<ApiState<unknown>['state']>();

  protected readonly logo$ = computed(() => this.results.findVersichererLogo$(this.bafinRegNr()));

  /** The price to show, or `null` when neither a confirmed nor a provisional one is known. */
  protected readonly price = computed(() => {
    const confirmed = this.state() === 'success' ? this.confirmedBetrag() : null;
    if (confirmed !== null) return { betrag: confirmed, provisional: false };
    const provisional = this.provisionalBetrag();
    return provisional === null ? null : { betrag: provisional, provisional: true };
  });
}
